import api from "./axiosInstance";

export interface CartItem {
  priceId: number;
  quantity: number;
}

export interface CreatePaymentCartRequest {
  attendeeId: number;
  items: CartItem[];
}

export interface PaymentCart {
  id: string;
  attendeeId: number;
  totalAmount: number;
  currency: string;
  status: string;
  items: {
    id: string;
    priceId: number;
    quantity: number;
    unitAmount: number;
    totalAmount: number;
    price: {
      id: number;
      numberOfClasses: number;
      specialType: string;
      amount: number;
      currency: string;
    };
  }[];
  createdAt: string;
  updatedAt: string;
}

export interface StripeCheckoutResponse {
  sessionId: string;
  url: string;
  transactionId: string;
  refno: string;
}

// Create a new payment cart
export const createPaymentCartApi = (data: CreatePaymentCartRequest) =>
  api.post<PaymentCart>("/payment-cart", data);

// Process manual payment for a cart
export const processManualCartPaymentApi = (cartId: string) =>
  api.post(`/payment-cart/${cartId}/process-manual`);

// Create Stripe checkout session for a cart
export const createCartStripeCheckoutApi = (cartId: string) =>
  api.post<StripeCheckoutResponse>(
    `/payment-cart/${cartId}/create-stripe-checkout`
  );

// Get cart details
export const getPaymentCartApi = (cartId: string) =>
  api.get<PaymentCart>(`/payment-cart/${cartId}`);

// Get carts by attendee
export const getCartsByAttendeeApi = (attendeeId: number) =>
  api.get<PaymentCart[]>(`/payment-cart/attendee/${attendeeId}`);

// Update cart
export const updatePaymentCartApi = (
  cartId: string,
  data: CreatePaymentCartRequest
) => api.patch<PaymentCart>(`/payment-cart/${cartId}`, data);

// Delete cart
export const deletePaymentCartApi = (cartId: string) =>
  api.delete(`/payment-cart/${cartId}`);
